import { Asset } from '../..';
import { privatePensionLoadedState } from '../../../../../../../../store/product/atom/privatePension';
import {
  privatePensionQueryUpdated,
  privatePensionCustomFiltersQuery,
} from '../../../../../../../../store/product/selectors';

import { PrivatePensionItem } from './ListItem';
import { ListLoadingItem } from './ListLoadingItem';

export const PrivatePensionAsset = () => {
  return (
    <Asset
      productsQuery={privatePensionQueryUpdated}
      customFiltersQuery={privatePensionCustomFiltersQuery}
      ProductItem={PrivatePensionItem}
      ProductItemLoading={ListLoadingItem}
      atomToSetProductsLoaded={privatePensionLoadedState}
      keySelector="privatePensionId"
    />
  );
};
